import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "accessibility-menu" }

import useTranslations from '@/composables/useTranslations';


export default /*@__PURE__*/_defineComponent({
  __name: 'AccessibilityMenu',
  setup(__props) {

const { translate: t } = useTranslations();
function focusOnContent(targetContentSelector: string) {
  const targetContent = document.querySelector(targetContentSelector) as HTMLElement;
  if (targetContent) {
    targetContent.setAttribute('tabindex', '-1'); // Make it focusable if it isn't
    targetContent.focus(); // Shift focus to the main content
    targetContent.removeAttribute('tabindex');
  }
}

function focusOnMainContent() {
  focusOnContent('.user-area--content');
  focusOnContent('.main-content');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: "accessibility-menu__skip-content",
          href: "#",
          onClick: _withModifiers(focusOnMainContent, ["prevent"])
        }, _toDisplayString(_unref(t)('Accessibility.SkipToMainContent')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: "accessibility-menu__skip-main-navigation",
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (focusOnContent('.mega-menu')), ["prevent"]))
        }, _toDisplayString(_unref(t)('Accessibility.SkipToMainNavigation')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: "accessibility-menu__skip-footer",
          href: "#",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (focusOnContent('.footer')), ["prevent"]))
        }, _toDisplayString(_unref(t)('Accessibility.SkipToFooter')), 1)
      ])
    ])
  ]))
}
}

})